import axiosFlow from '@/services/axios/axiosFlow'
import GetTicketByIdModel from '@/models/responses/ticket/GetTicketByIdModel'

export default class TicketService {
  static async getEstatisticasFilaDeAtendimento(filaId, email, protocolo, atendenteId, agenteSelecionado) {
    const params = new URLSearchParams()

    if (filaId) { params.append('FilaId', filaId) }
    if (email) { params.append('ClienteEmail', email) }
    if (protocolo) { params.append('Protocolo', protocolo) }

    if (atendenteId) {
      params.append('IntegranteId', atendenteId)
    } else if (agenteSelecionado) {
      params.append('IntegranteId', agenteSelecionado)
    }

    return axiosFlow.get(`tickets/estatisticas?${params.toString()}`).then(res => res.data.data)
  }

  static async getTickets(filaId, paginaAtual, itensPorPagina, filtroAgenteSelecionado, filtroEmail, filtroProtocolo, filtroCategoriaListagem, filtroSlaTipoId, filtroSlaTipoAlertaId) {
    const params = new URLSearchParams()

    params.append('Pagina', paginaAtual - 1)
    params.append('ItensPorPagina', itensPorPagina)
    params.append('FilaId', filaId)

    if (filtroAgenteSelecionado) { params.append('AtendenteId', filtroAgenteSelecionado) }
    if (filtroEmail) { params.append('SolicitanteEmail', filtroEmail) }
    if (filtroProtocolo) { params.append('Protocolo', filtroProtocolo) }
    if (filtroCategoriaListagem) { params.append('CategoriaListagem', filtroCategoriaListagem) }
    if (filtroSlaTipoId) { params.append('SlaTipoId', filtroSlaTipoId) }
    if (filtroSlaTipoAlertaId) { params.append('SlaTipoAlertaId', filtroSlaTipoAlertaId) }

    return axiosFlow.get(`tickets?${params}`).then(res => res.data.data)
  }

  static async getTicketsFilasAgrupadas(paginaAtual, itensPorPagina, filtroAgenteSelecionado, filtroEmail, filtroProtocolo, filtroCategoriaListagem, filtroSlaTipoId, filtroSlaTipoAlertaId) {
    const params = new URLSearchParams()

    params.append('Pagina', paginaAtual - 1)
    params.append('ItensPorPagina', itensPorPagina)

    if (filtroAgenteSelecionado) { params.append('AtendenteId', filtroAgenteSelecionado) }
    if (filtroEmail) { params.append('SolicitanteEmail', filtroEmail) }
    if (filtroProtocolo) { params.append('Protocolo', filtroProtocolo) }
    if (filtroCategoriaListagem) { params.append('CategoriaListagem', filtroCategoriaListagem) }
    if (filtroSlaTipoId) { params.append('SlaTipoId', filtroSlaTipoId) }
    if (filtroSlaTipoAlertaId) { params.append('SlaTipoAlertaId', filtroSlaTipoAlertaId) }

    return axiosFlow.get(`tickets/filas-agrupadas?${params.toString()}`).then(res => res.data.data)
  }

  static async getTicketById(ticketId) {
    return new GetTicketByIdModel(await axiosFlow.get(`tickets/${ticketId}`).then(res => res.data.data))
  }

  static async getTicketByProtocolo(protocolo) {
    return axiosFlow.get(`tickets/protocolo?protocolo=${protocolo}`).then(res => res.data.data)
  }

  static async getSecaoDefaultDadosDoSolicitante(filaId) {
    const url = `tickets/formulario/secoes/dados-solicitante?FilaId=${filaId}`
    return axiosFlow.get(url).then(res => res.data.data)
  }

  static async getSecaoDefaultMensagens(filaId) {
    const url = `tickets/formulario/secoes/mensagens?FilaId=${filaId}`
    return axiosFlow.get(url).then(res => res.data.data)
  }

  static async getTiposDeSolicitacoes(filaId) {
    return axiosFlow.get(`tickets/${filaId}/tipos-solicitacoes/atendimento?ItensPorPagina=100`).then(res => res.data.data.items)
  }

  static async getStatusAtivos(filaId) {
    const data = await axiosFlow.get(`filas/${filaId}/status-ticket`).then(res => res.data.data)
    return data.filter(st => st.ativo)
  }

  static async getFormulariosTicket(filaId, tipoSolicitacaoId, ticketId) {
    let url = `tickets/formulario/secoes?FilaId=${filaId}`
    url += !tipoSolicitacaoId ? '' : `&TipoSolicitacaoId=${tipoSolicitacaoId}`
    url += !ticketId ? '' : `&TicketId=${ticketId}`
    return axiosFlow.get(url).then(res => res.data.data)
  }

  static async getMensagens(ticketId) {
    return axiosFlow.get(`tickets/${ticketId}/mensagens`).then(res => res.data.data)
  }

  static async getSlasTicket(ticketId) {
    return axiosFlow.get(`tickets/${ticketId}/slas`).then(res => res.data.data)
  }

  static async getTicketHistorico(ticketId, date) {
    const params = new URLSearchParams()

    if (date) {
      params.append('DataCadastro', date)
    }

    return axiosFlow.get(`tickets/${ticketId}/historico?${params}`)
  }

  static async getTicketHistoricoStatus(ticketId) {
    return axiosFlow.get(`tickets/${ticketId}/historico/status`).then(res => res.data.data)
  }

  static async getTicketHistoricoAtendentes(ticketId) {
    return axiosFlow.get(`tickets/${ticketId}/historico/atendentes`).then(res => res.data.data)
  }

  static async getTicketHistoricoAlteracoes(ticketId) {
    return axiosFlow.get(`tickets/${ticketId}/historico/alteracoes`).then(res => res.data.data)
  }

  static async getTicketAgendamentos(ticketId) {
    return axiosFlow.get(`tickets/${ticketId}/agendamentos`).then(res => res.data.data)
  }

  static async getAgenteAgendamentos(dataInicio, dataFim, agenteId) {
    const params = new URLSearchParams()

    if (dataInicio) {
      params.append('DataInicio', dataInicio)
    }
    if (dataFim) {
      params.append('DataFim', dataFim)
    }
    // Se vier agenteId, manda. Se não, o backend que decida (ou pega do token)
    if (agenteId) {
      params.append('AgenteId', agenteId)
      // Confirme se o parametro no Backend é AgenteId ou GestorId/UsuarioId
    }

    return axiosFlow.get(`tickets/agendamentos/agentes?${params}`).then(res => res.data.data)
  }

  static async getAgenteAgendamentosComentarios(agendamentoId) {
    return axiosFlow.get(`tickets/agendamentos/${agendamentoId}/agentes/comentarios`).then(res => res.data.data)
  }

  static async getAgendamentosStatus() {
    return axiosFlow.get('tickets/agendamentos/status').then(res => res.data.data)
  }

  static async getDisponibilidadesAgenteParaAgendamento(ticketId, agenteId, dataInicio, dataFim) {
    const params = new URLSearchParams()

    if (dataInicio) {
      params.append('DataInicio', dataInicio)
    }
    if (dataFim) {
      params.append('DataFim', dataFim)
    }

    return axiosFlow.get(`tickets/${ticketId}/agendamentos/agentes/${agenteId}/disponibilidades?${params}`).then(res => res.data.data)
  }

  static async criarTicketManual(body) {
    return axiosFlow.post('tickets/abertura-manual', body).then(res => res.data.data)
  }

  static async updateTicket(ticketId, body) {
    return axiosFlow.put(`tickets/${ticketId}`, body)
  }

  static async encaminharTicket(ticketId, filaId, agenteId) {
    return axiosFlow.post(`tickets/${ticketId}/encaminhar`, { filaId, agenteId })
  }

  static async enviarMensagemAgente(ticketId, body) {
    return axiosFlow.post(`tickets/${ticketId}/mensagens/agentes`, body)
  }

  static async criarAgendamento(ticketId, body) {
    return axiosFlow.post(`tickets/${ticketId}/agendamentos`, body)
  }

  static async atualizarAgendamentosStatus(ticketId, agendamentoId, body) {
    return axiosFlow.put(`tickets/${ticketId}/agendamentos/${agendamentoId}/status`, body)
  }

  static async criarAgendamentoComentario(agendamentoId, body) {
    return axiosFlow.post(`tickets/agendamentos/${agendamentoId}/comentarios`, body)
  }

  static async atualizarAgendamentoComentario(agendamentoId, comentarioId, body) {
    return axiosFlow.put(`tickets/agendamentos/${agendamentoId}/comentarios/${comentarioId}`, body)
  }
}
